/* eslint-disable indent */

export default class SpecialTouches extends CoreJS.BaseComponent {
  static CLASS_NAMESPACE = 'special-touches';
  
  /** @inheritDoc */
  constructor(componentHost, componentName) {
    super(componentHost, componentName);
    this.carouselList = this.componentHost.querySelector('.special-touches__list');
    this.leftButton = this.componentHost.querySelector('.special-touches__actions .left');
    this.rightButton = this.componentHost.querySelector('.special-touches__actions .right');
    this.currentSlide = this.componentHost.querySelector('.counter__current-value');
    this.itemsCount = this.carouselList?.dataset.itemsCount;
    this.itemWidth = this.componentHost.querySelector('.special-touches__item')?.offsetWidth;
    this.carouselContainers = this.componentHost.querySelectorAll('.special-touches__item--container');
    this.activeIndex = 0;
    this.scrollPosition = 0;

    this.initCarousel();
    this.initSwipe();
    this.observeResize(); 
    this.observeActiveVideo();
  }

  /** @inheritDoc */
  initialize() {
    super.initialize();
  }

  getScrollLeftValue(isSlidingRight) {
    const scrollValue = this.itemWidth;
    this.scrollPosition += isSlidingRight ? scrollValue : -scrollValue;
    return this.scrollPosition;
  }

  toggleActiveClass() {
    this.componentHost.querySelectorAll('[data-item-index]').forEach(item => {
      item.classList.remove('active');
      item.querySelector('video')?.pause();
    });
    this.componentHost.querySelector(`[data-item-index="${this.activeIndex}"]`).classList.add('active');
    const video = this.componentHost.querySelector(`[data-item-index="${this.activeIndex}"] video`)
    
    if(video){
      video.currentTime = 0;
      video.play();
    }
  }

  slideRight() {
    if (this.activeIndex < this.itemsCount - 1) {
      this.carouselList.style.marginLeft = `-${this.getScrollLeftValue(true)}px`;
      this.activeIndex++;
      this.updateSlideInfo();
      this.toggleButtonsState();
      this.toggleActiveClass();
    }
  }

  slideLeft() {
    this.carouselList.style.marginLeft = `-${this.getScrollLeftValue(false)}px`;
    this.activeIndex--;
    this.updateSlideInfo();
    this.toggleButtonsState();
    this.toggleActiveClass();
  }

  updateSlideInfo() {
    this.currentSlide.innerHTML = this.activeIndex + 1;
  }

  toggleButtonsState() {
    this.leftButton.disabled = this.activeIndex === 0;
    this.rightButton.disabled = this.activeIndex === this.itemsCount - 1;
  }

  initCarousel() {
    this.rightButton.addEventListener('click', () => this.slideRight());
    this.leftButton.addEventListener('click', () => this.slideLeft());
  }

  initSwipe() {
    let startX, startY;
    this.carouselList.addEventListener('touchstart', e => {
      const { pageX, pageY } = e.touches[0];
      startX = pageX;
      startY = pageY;
    });

    this.carouselList.addEventListener('touchend', e => {
      const { pageX, pageY } = e.changedTouches[0];
      const diffX = pageX - startX;
      const diffY = pageY - startY;

      if (Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX > 0) {
          this.slideLeft();
        } else {
          this.slideRight();
        }
      }
    });
  }

  observeResize() {
    window.addEventListener('resize', () => {
      this.recalculateItemWidth();
    });
  }

  recalculateItemWidth() {
    const item = this.componentHost.querySelector('.special-touches__item');
    if (item) {
      this.itemWidth = item.offsetWidth;
      this.scrollPosition = this.activeIndex * this.itemWidth;
      this.carouselList.style.marginLeft = `-${this.scrollPosition}px`; 
    }
  }

  observeActiveVideo() {
    this.carouselContainers.forEach(container => {
      container.addEventListener('mouseover', (event) => {
        const target = event.target?.closest('.special-touches__item--container');
        const video = target.querySelector('video')
        if(video){
          video?.pause();
          video.currentTime = 0;
          video.play();
        }
      });
      container.addEventListener('focus', (event) => {
        const target = event.target;
        const video = target.querySelector('video')
        if(video){
          video?.pause();
          video.currentTime = 0;
          video.play();
        }
      });
    });
  }

}

CoreJS.BaseComponent.registerComponent(
  SpecialTouches.CLASS_NAMESPACE,
  SpecialTouches,
  true,
);
